import { Loader } from '@/components/ui/loader';
import {
  SkeletonCard,
  SkeletonList,
  SkeletonStatRow,
  SkeletonTournamentGrid,
  SkeletonTournamentDetail,
} from '@/components/SkeletonCard';
import { cn } from '@/lib/utils';

type PageLoadingVariant = 'spinner' | 'cards' | 'list' | 'stats' | 'tournaments' | 'tournament-detail';

interface PageLoadingProps {
  text?: string;
  className?: string;
  minHeight?: string;
  variant?: PageLoadingVariant;
}

export const PageLoading = ({
  text = 'Cargando...',
  className,
  minHeight = 'min-h-[320px]',
  variant = 'spinner',
}: PageLoadingProps) => {
  if (variant === 'spinner') {
    return (
      <div
        className={cn(
          'flex items-center justify-center rounded-2xl border border-primary/10 bg-primary/5 backdrop-blur-xl',
          minHeight,
          className,
        )}
      >
        <Loader size="lg" text={text} />
      </div>
    );
  }

  const skeletonContent = {
    cards: (
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    ),
    list: <SkeletonList />,
    stats: <SkeletonStatRow />,
    tournaments: <SkeletonTournamentGrid />,
    'tournament-detail': <SkeletonTournamentDetail />,
  }[variant];

  return (
    <div className={cn('space-y-4', minHeight, className)}>
      {text && variant !== 'stats' && (
        <p className="text-sm text-muted-foreground/80 animate-pulse">{text}</p>
      )}
      {skeletonContent}
    </div>
  );
};
